<template>
  <div>
    <invoice-form/>
  </div>
</template>

<script>
import InvoiceForm from '@/components/invoice-form.vue'

export default {
  name: 'InvoiceView',
  components: {
    InvoiceForm
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/app/children/invoice.view.vue